module.exports = __webpack_public_path__ + "static/media/SelfQueryLogo.849fe6c3.png";